import { translate } from '@/domains/core/localization/translate';
export const {
  title,
  subtitle
} = translate({
  "title": "Did you find what you were looking for?",
  "subtitle": "If not, please try to rephrase your search."
});